    import {find, propEq} from 'ramda'

    class reminderEmailCtrl {
        /* @ngInject*/
      constructor ($mdToast, $mdDialog, ManageJobs, job) {
        this.$mdToast = $mdToast
        this.$mdDialog = $mdDialog
        this.mj = ManageJobs
        this.job = job

        this.emails = []
        this.email = ''
        this.subject = ''
        this.message = ''

        this.templates = [
            {id: 1, title: 'Download Manager App', message: 'Log into the manager app to see the roster, clock employees in, and rate your workforce'}
        ]

        this.messageTemplateInd
      }

      changeMessageTemplate () {
        this.message = find(propEq('id', this.messageTemplateInd))(this.templates).message
      }

      fieldsAreFilled () {
        return !!this.emails.length && !!this.subject.length && !!this.message.length
      }

      addEmail () {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (re.test(this.email)) {
          this.emails.push(this.email)
          this.email = ''
        }
      }

      cancel () {
        this.$mdDialog.cancel()
      }

      confirm () {
        let call = {
          jobId: this.job.external_id,
          customFilledMessage: this.message,
          ccUsers: this.emails,
          customSubject: this.subject
        }

        this.mj.sendReminderEmail(call)
            .then(res => {
              this.$mdToast.showSimple('Succesfully Sent Reminder Emails')
            })
        this.$mdDialog.hide()
      }
    }

    export default reminderEmailCtrl
